import { useContext, createContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getData } from "../../FetchNodeServices";
import { useDispatch } from "react-redux";
import { deleteUser } from "../../redux/userSlice";
import { deleteSubUser } from "../../redux/subuserSlice";
import { jwtDecode } from "jwt-decode";

const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(JSON.parse(localStorage.getItem("user")) || null);
  const [token, setToken] = useState(localStorage.getItem("token") || "");
  const [tokenValidity, setTokenValidity] = useState(null);
  let navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    verifyToken();
  }, []);

  const verifyToken = () => {
    if (token) {
      try {
        const decodedToken = jwtDecode(token);
        setTokenValidity(decodedToken.exp * 1000);
        if (decodedToken.exp * 1000 < Date.now()) {
          logOut();
        } else {
          setUser(JSON.parse(localStorage.getItem("user")));
          // navigate("/dashboard", { replace: true });
        }
      } catch (err) {
        console.error(err);

        logOut();
      }
    }
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      if (tokenValidity && tokenValidity < Date.now()) {
        logOut();
      }
    }, 1000);

    return () => clearInterval(intervalId);
  }, [tokenValidity]);

  const loginAction = async (formData) => {
    try {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      dispatch(deleteUser());
      //    http://localhost:8081/users/generate-token

      const response = await fetch("https://user.the-capacity.com/users/generate-token ", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });
      const res = await response.json();
      console.log("response", response.ok);
      if (response.ok && res.token) {
        localStorage.setItem("token", res.token);

        const userDetails = await getData("/users/welcome");
        localStorage.setItem("user", JSON.stringify(userDetails));
        setUser(userDetails);

        navigate("/dashboard", { replace: true });
        return true;
      }
      throw new Error(res.message);
    } catch (err) {
      console.error(err);
      return false;
    }
  };

  const logOut = () => {
    setUser(null);

    setToken("");
    setTokenValidity(null);
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    dispatch(deleteUser());
    dispatch(deleteSubUser());
    navigate("/");
  };

  return <AuthContext.Provider value={{ token, user, loginAction, logOut }}>{children}</AuthContext.Provider>;
};

export default AuthProvider;

export const useAuth = () => {
  return useContext(AuthContext);
};
